import { SendOutcome } from "./SyncWorker";

/**
 * Map a thrown error from a tRPC call into a SendOutcome for the sync
 * worker. 401/403 are transient (token refresh recovers); other 4xx are
 * permanent client errors that should drop the queue entry; everything
 * else (5xx, network errors, unknown shapes) is transient.
 */
export function classifyTrpcError(err: unknown): SendOutcome {
  const status = (err as { data?: { httpStatus?: number } })?.data?.httpStatus;

  if (status === 401 || status === 403) {
    return SendOutcome.Transient;
  }

  if (status != null && status >= 400 && status < 500) {
    return SendOutcome.ClientError;
  }

  return SendOutcome.Transient;
}
